export const mockData = {
  resources: [
    {
      id: 0, 
      name: "syringe",
      costPerUnit: "£12.99",
      quantity: "300",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 1, 
      name: "laser",
      costPerUnit: "£25",
      quantity: "520",
      autoPurchaseLevel: "400",
      isAutoPurchase: false,
      category: "Health",
    },
    {
      id: 2, 
      name: "Dental Floss",
      costPerUnit: "£5.50",
      quantity: "560",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 3, 
      name: "Mouthwash",
      costPerUnit: "£8.99",
      quantity: "500",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 4, 
      name: "Toothbrush",
      costPerUnit: "£4.25",
      quantity: "50",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 5,       
      name: "Surgical Gloves",
      costPerUnit: "£45.99",
      quantity: "4300",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 6, 
      name: "Scalpel",
      costPerUnit: "£22.75",
      quantity: "60",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 7,
      name: "Dental Mirror",
      costPerUnit: "£7.50",
      quantity: "321",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 8,
      name: "X-Ray Machine",
      costPerUnit: "£2500",
      quantity: "222",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 9,
      name: "Filling Material",
      costPerUnit: "£175.25",
      quantity: "2600",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 10,
      name: "Dental Drill",
      costPerUnit: "£285",
      quantity: "980",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 11,
      name: "Anaesthesia",
      costPerUnit: "£75.99",
      quantity: "830",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 12,
      name: "Toothpaste",
      costPerUnit: "£6.25",
      quantity: "70",
      autoPurchaseLevel: "500",
      isAutoPurchase: false,
      category: "Health",
    },
    {
      id: 13,
      name: "Implants",
      costPerUnit: "£1200",
      quantity: "210",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 14,
      name: "Sutures",
      costPerUnit: "£12.99",
      quantity: "40",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 15,
      name: "Surgical Masks",
      costPerUnit: "£15.50",
      quantity: "500",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 16,
      name: "Sterilization Machine",
      costPerUnit: "£1500",
      quantity: "970",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 17,
      name: "Orthodontic Pliers",
      costPerUnit: "£90.75",
      quantity: "5430",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 18,
      name: "Dental Light",
      costPerUnit: "£125",
      quantity: "123",
      autoPurchaseLevel: "500",
      isAutoPurchase: false,
      category: "Health",
    },
    {
      id: 19,
      name: "Rubber Dam",
      costPerUnit: "£28.99",
      quantity: "312",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Admin",
    },
    {
      id: 20,
      name: "Periodontal Probe",
      costPerUnit: "£24.50",
      quantity: "532",
      autoPurchaseLevel: "500",
      isAutoPurchase: true,
      category: "Health",
    },
    {
      id: 21,
      name: "Cavity Liner",
      costPerUnit: "£42.25",
      quantity: "560",
      autoPurchaseLevel: "500",
      isAutoPurchase: false,
      category: "Health",
    },
  ],

  resourcesRequest: [
    { resourceId: 3,
      category: "Health",
      staffMember: "Marianna",
      resources: "Mouthwash",
      autoPurchase: "yes",
      autoPurchaseLevel: "210",
      requestQuantity: "10",
    },
    {
      resourceId: 13,
      category: "Admin",
      staffMember: "Stefania",
      resources: "Implants",
      autoPurchase: "no",
      autoPurchaseLevel: "413",
      requestQuantity: "50",
    },
    {
      resourceId: 7,
      category: "Health",
      staffMember: "David",
      resources: "Dental Mirror",
      autoPurchase: "no",
      autoPurchaseLevel: "378",
      requestQuantity: "20",
    },
    {
      id: 3,
      category: "Health",
      staffMember: "Julia",
      resources: "Sutures",
      autoPurchase: "no",
      autoPurchaseLevel: "219",
      requestQuantity: "90",
    },
    {
      id: 4,
      category: "Admin",
      staffMember: "Elisabeth",
      resources: "Sterilization Machine",
      autoPurchase: "yes",
      autoPurchaseLevel: "27",
      requestQuantity: "60",
    },
    {
      id: 5,
      category: "Health",
      staffMember: "Roberto",
      resources: "Dental Light",
      autoPurchase: "yes",
      autoPurchaseLevel: "171",
      requestQuantity: "80",
    },
    {
      id: 6,
      category: "Admin",
      staffMember: "Carla",
      resources: "Surgical Gloves",
      autoPurchase: "yes",
      autoPurchaseLevel: "359",
      requestQuantity: "100",
    },
    {
      id: 7,
      category: "Health",
      staffMember: "Simon",
      resources: "Periodontal Probe",
      autoPurchase: "yes",
      autoPurchaseLevel: "40",
      requestQuantity: "50",
    },
    {
      id: 8,
      category: "Admin",
      staffMember: "Roberto",
      resources: "X-Ray Machine",
      autoPurchase: "no",
      autoPurchaseLevel: "490",
      requestQuantity: "2",
    },
    {
      id: 9,
      category: "Health",
      staffMember: "Carla",
      resources: "Dental Drill",
      autoPurchase: "no",
      autoPurchaseLevel: "37",
      requestQuantity: "10",
    },
    {
      id: 10,
      category: "Admin",
      staffMember: "Julia",
      resources: "Orthodontic Pliers",
      autoPurchase: "yes",
      autoPurchaseLevel: "468",
      requestQuantity: "10",
    },
    {
      id: 11,
      category: "Health",
      staffMember: "Stefania",
      resources: "Filling Material",
      autoPurchase: "no",
      autoPurchaseLevel: "283",
      requestQuantity: "70",
    },
    {
      id: 12,
      category: "Admin",
      staffMember: "David",
      resources: "Rubber Dam",
      autoPurchase: "yes",
      autoPurchaseLevel: "16",
      requestQuantity: "100",
    },
    {
      id: 13,
      category: "Health",
      staffMember: "Simon",
      resources: "Anaesthesia",
      autoPurchase: "no",
      autoPurchaseLevel: "325",
      requestQuantity: "100",
    },
    {
      id: 14,
      category: "Admin",
      staffMember: "Marianna",
      resources: "Cavity Liner",
      autoPurchase: "no",
      autoPurchaseLevel: "145",
      requestQuantity: "10",
    },
    {
      id: 15,
      category: "Health",
      staffMember: "Simon",
      resources: "Toothpaste",
      autoPurchase: "yes",
      autoPurchaseLevel: "127",
      requestQuantity: "150",
    },
    {
      id: 16,
      category: "Admin",
      staffMember: "Carla",
      resources: "Surgical Masks",
      autoPurchase: "yes",
      autoPurchaseLevel: "97",
      requestQuantity: "200",
    },
    {
      
      category: "Admin",
      staffMember: "David",
      resources: "Dental Drill",
      autoPurchase: "no",
      autoPurchaseLevel: "405",
      requestQuantity: "50",
    },
  ],

  staff: [
    {
      name: "Stefania",
      role: "Dentist",
      overview:
        "Stefania has been a part of our team since 2020. She is an experienced dentist with a passion for helping her patients achieve the perfect smile. Stefania has a friendly and caring approach, and always goes the extra mile to make sure her patients feel comfortable during their appointments.",
      startDate: "01.01.2020",
      contractEndDate: "01.01.2025",
      manager: "George",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    },
    {
      name: "David",
      role: "Dentist",
      overview:
        "David is a skilled dentist who has been with our practice since 2015. He is committed to providing high-quality care to his patients, and always takes the time to explain their treatment options in detail. David has a gentle and reassuring manner, and is always willing to go above and beyond to ensure his patients feel comfortable and confident.",
      startDate: "15.07.2015",
      contractEndDate: "15.07.2024",
      manager: "Harry",
      image:
        "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80",
    },
    {
      name: "Julia",
      role: "Dentist",
      overview:
        "Julia has been practicing dentistry for over a decade, and brings a wealth of knowledge and experience to our team. She is passionate about staying up-to-date with the latest advances in dental technology and techniques, and is always looking for ways to improve her patients' experience. Julia has a warm and friendly personality, and is committed to providing exceptional care to each and every patient she sees.",
      startDate: "30.09.2022",
      contractEndDate: "30.09.2025",
      manager: "Sarah",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80",
    },
    {
      name: "Marianna",
      role: "Assistant",
      overview:
        "Marianna is a highly skilled dental assistant who has been a part of our team since 2018. She is dedicated to providing excellent support to our dentists and ensuring that our patients receive the best possible care. Marianna is a great listener, and always takes the time to understand her patients' needs and concerns. She is a valuable asset to our practice, and we are lucky to have her on our team.",
      startDate: "25.02.2018",
      contractEndDate: "25.02.2024",
      manager: "George",
      image:
        "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80",
    },
    {
      name: "Roberto",
      role: "Assistant",
      overview:
        "Roberto is a hardworking and reliable dental assistant who joined our team in 2019. He is dedicated to providing top-notch support to our dentists and ensuring that our patients receive the best possible care. Roberto is a great team player, and always goes above and beyond to help out his colleagues. He is an asset to our practice, and we are lucky to have him on board.",
      startDate: "12.11.2019",
      contractEndDate: "12.11.2024",
      manager: "Harry",
      image:
        "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    },
    {
      name: "Elisabeth",
      role: "Assistant",
      overview:
        "Elisabeth is a skilled and compassionate dental assistant who has been with our practice since 2017. She is passionate about providing the highest quality care to our patients, and is always looking for ways to improve their experience. Elisabeth has a friendly and approachable personality, and is always willing to go the extra mile to ensure her patients feel comfortable and at ease. She is a valuable member of our team, and we feel fortunate to have her with us.",
      startDate: "18.06.2017",
      contractEndDate: "18.06.2025",
      manager: "Sarah",
      image:
        "https://images.unsplash.com/photo-1544717305-2782549b5136?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80",
    },
    {
      name: "Carla",
      role: "Dentist",
      overview:
        "Carla is a friendly and professional dentist who joined our team in 2020. She is always ready to greet our patients with a smile, and is dedicated to ensuring that their experience at our practice is a positive one. Carla has excellent communication skills, and is able to answer any questions or concerns our patients may have. She is a valuable member of our team, and we are grateful to have her with us.",
      startDate: "08.03.2020",
      contractEndDate: "08.03.2024",
      manager: "George",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=461&q=80",
    },
    {
      name: "Simon",
      role: "Assistant",
      overview:
        "Simon is a skilled and efficient assistant who has been with our practice since 2016. He is committed to providing excellent customer service to our patients, and always goes above and beyond to ensure that their needs are met. Simon has a friendly and outgoing personality, and is always happy to help in any way he can. He is an important member of our team, and we are fortunate to have him with us.",
      startDate: "22.09.2016",
      contractEndDate: "22.09.2025",
      manager: "Harry",
      image:
        "https://images.unsplash.com/photo-1552058544-f2b08422138a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=399&q=80",
    },
  ],

  clients: [
    {
      id: 1,
      firstName: "Mariah",
      lastName: "Chan",
      email: "mariahchan@gmail.com",
      mobile: "+44123456789",
      image:
        "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=689&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "David",
    },
    {
      id: 2,
      firstName: "Mark",
      lastName: "Wilson",
      email: "markwilson@gmail.com",
      mobile: "+44123456789",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consultant",
      hasAppointment: true,
      confirmedAppoinment: false,
      staff: "Elisabeth",
    },

    {
      id: 3,
      firstName: "Ashley",
      lastName: "Williams",
      email: "ashleywilliams@gmail.com",
      mobile: "+44123446869",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consumer",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "David",
    },
    {
      id: 4,
      firstName: "John",
      lastName: "Lee",
      email: "johnlee@gmail.com",
      mobile: "+441234567895",
      image:
        "https://images.unsplash.com/photo-1542327897-d73f4005b533?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consumer",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Julia",
    },
    {
      id: 5,
      firstName: "Karen",
      lastName: "Chen",
      email: "karenchen@gmail.com",
      mobile: "+441234567896",
      image:
        "https://images.unsplash.com/photo-1529232356377-57971f020a94?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=688&q=80",
      query: "consumer",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "David",
    },
    {
      id: 6,
      firstName: "Sean",
      lastName: "Baker",
      email: "seanbaker@gmail.com",
      mobile: "+441234567897",
      image:
        "https://images.unsplash.com/photo-1590086782792-42dd2350140d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consultant",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Roberto",
    },
    {
      id: 7,
      firstName: "Sophie",
      lastName: "Kim",
      email: "sophiekim@gmail.com",
      mobile: "+441234567898",
      image:
        "https://images.unsplash.com/photo-1541257710737-06d667133a53?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=685&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "Roberto",
    },
    {
      id: 8,
      firstName: "Adam",
      lastName: "Kim",
      email: "adamjohnson@gmail.com",
      mobile: "+441234567899",
      image:
        "https://images.unsplash.com/photo-1613053341193-2b7f654c155f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consultant",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "Marianna",
    },
    {
      id: 9,
      firstName: "Ethan",
      lastName: "Chen",
      email: "ethanchen@gmail.com",
      mobile: "+441234567900",
      image:
        "https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1471&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "David",
    },
    {
      id: 10,
      firstName: "Melanie",
      lastName: "Wong",
      email: "melaniewong@gmail.com",
      mobile: "+441234567901",
      image:
        "https://images.unsplash.com/photo-1498551172505-8ee7ad69f235?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "Julia",
    },
    {
      id: 11,
      firstName: "Peter",
      lastName: "Brown",
      email: "peterbrown@gmail.com",
      mobile: "+441234567902",
      image:
        "https://images.unsplash.com/photo-1522556189639-b150ed9c4330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consultant",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "David",
    },
    {
      id: 12,
      firstName: "Jasmine",
      lastName: "Wang",
      email: "jasminewang@gmail.com",
      mobile: "+441234567903",
      image:
        "https://images.unsplash.com/photo-1619443143113-9fc54b5609ad?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consumer",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Elisabeth",
    },
    {
      id: 13,
      firstName: "David",
      lastName: "Chen",
      email: "davidchen@gmail.com",
      mobile: "+441234567904",
      image:
        "https://images.unsplash.com/photo-1615269245458-ff1785d41332?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consumer",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Stefania",
    },
    {
      id: 14,
      firstName: "Alice",
      lastName: "Lee",
      email: "alicelee@gmail.com",
      mobile: "+441234567905",
      image:
        "https://images.unsplash.com/photo-1589698314382-629520d350cd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=698&q=80",
      query: "consultant",
      hasAppointment: true,
      confirmedAppoinment: false,
      staff: "Elisabeth",
    },
    {
      id: 15,
      firstName: "Rachel",
      lastName: "Kim",
      email: "rachelkim@gmail.com",
      mobile: "+441234567906",
      image:
        "https://images.unsplash.com/photo-1475823678248-624fc6f85785?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: false,
      staff: "Roberto",
    },
    {
      id: 16,
      firstName: "Alex",
      lastName: "Nguyen",
      email: "alexnguyen@gmail.com",
      mobile: "+441234567907",
      image:
        "https://images.unsplash.com/photo-1611403119860-57c4937ef987?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consultant",
      hasAppointment: true,
      confirmedAppoinment: false,
      staff: "David",
    },
    {
      id: 17,
      firstName: "Emily",
      lastName: "Brown",
      email: "emilybrown@gmail.com",
      mobile: "+441234567908",
      image:
        "https://images.unsplash.com/photo-1554727242-741c14fa561c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consumer",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Marianna",
    },
    {
      id: 18,
      firstName: "Jason",
      lastName: "Lee",
      email: "jasonlee@gmail.com",
      mobile: "+441234567909",
      image:
        "https://images.unsplash.com/photo-1487309078313-fad80c3ec1e5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=735&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "Roberto",
    },
    {
      id: 19,
      firstName: "Erica",
      lastName: "Chen",
      email: "ericachen@gmail.com",
      mobile: "+441234567910",
      image:
        "https://images.unsplash.com/photo-1514161955277-4ea47eef2ff9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      query: "consultant",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Elisabeth",
    },
    {
      id: 20,
      firstName: "Bryan",
      lastName: "Kim",
      email: "bryankim@gmail.com",
      mobile: "+441234567911",
      image:
        "https://images.unsplash.com/photo-1594546325110-a530729c3f99?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1752&q=80",
      query: "consumer",
      hasAppointment: true,
      confirmedAppoinment: false,
      staff: "Julia",
    },
    {
      id: 21,
      firstName: "Chloe",
      lastName: "Wong",
      email: "chloewong@gmail.com",
      mobile: "+4412345758543",
      query: "consumer",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      hasAppointment: false,
      confirmedAppoinment: false,
      staff: "Roberto",
    },
    {
      id: 22,
      firstName: "Daniel",
      lastName: "Lee",
      email: "daniellee@gmail.com",
      mobile: "+441234558543",
      query: "consumer",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      hasAppointment: true,
      confirmedAppoinment: true,
      staff: "Julia",
    },
    {
      id: 23,
      firstName: "Brad",
      lastName: "Pitt",
      email: "bpitt@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Brad_Pitt_2019_by_Glenn_Francis.jpg/330px-Brad_Pitt_2019_by_Glenn_Francis.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
    {
      id: 24,
      firstName: "Jennifer",
      lastName: "Aniston",
      email: "janiston@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/JenniferAnistonFeb09.jpg/330px-JenniferAnistonFeb09.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Marianna",
    },
    {
      id: 25,
      firstName: "Leonardo",
      lastName: "DiCaprio",
      email: "ldicaprio@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Leonardo_DiCaprio_2014.jpg/330px-Leonardo_DiCaprio_2014.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Stefania",
    },
    {
      id: 26,
      firstName: "Angelina",
      lastName: "Jolie",
      email: "ajolie@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Under_Secretary_Zeya_Meets_With_UNHCR_Special_Envoy_Jolie_%2851942861677%29_%28cropped%29.jpg/330px-Under_Secretary_Zeya_Meets_With_UNHCR_Special_Envoy_Jolie_%2851942861677%29_%28cropped%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Carla",
    },
    {
      id: 27,
      firstName: "Tom",
      lastName: "Hanks",
      email: "thanks@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Tom_Hanks_TIFF_2019.jpg/330px-Tom_Hanks_TIFF_2019.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Roberto",
    },
    {
      id: 28,
      firstName: "Meryl",
      lastName: "Streep",
      email: "mstreep@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Meryl_Streep_December_2018.jpg/330px-Meryl_Streep_December_2018.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 29,
      firstName: "George",
      lastName: "Clooney",
      email: "gclooney@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/George_Clooney_2016.jpg/330px-George_Clooney_2016.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Elisabeth",
    },
    {
      id: 30,
      firstName: "Oprah",
      lastName: "Winfrey",
      email: "owinfrey@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Oprah_in_2014.jpg/330px-Oprah_in_2014.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Simon",
    },
    {
      id: 31,
      firstName: "Will",
      lastName: "Smith",
      email: "wsmith@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/TechCrunch_Disrupt_2019_%2848834434641%29_%28cropped%29.jpg/330px-TechCrunch_Disrupt_2019_%2848834434641%29_%28cropped%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
    {
      id: 32,
      firstName: "Emma",
      lastName: "Watson",
      email: "ewatson@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Emma_Watson_2013.jpg/330px-Emma_Watson_2013.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Marianna",
    },
    {
      id: 33,
      firstName: "Robert",
      lastName: "De Niro",
      email: "rdeniro@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Robert_De_Niro_2011_Shankbone.JPG/330px-Robert_De_Niro_2011_Shankbone.JPG",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Stefania",
    },
    {
      id: 34,
      firstName: "Nicole",
      lastName: "Kidman",
      email: "nkidman@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Nicole_Kidman_Cannes_2017.jpg/330px-Nicole_Kidman_Cannes_2017.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Carla",
    },
    {
      id: 35,
      firstName: "Matt",
      lastName: "Damon",
      email: "mdamon@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Matt_Damon_TIFF_2015.jpg/330px-Matt_Damon_TIFF_2015.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Roberto",
    },
    {
      id: 36,
      firstName: "Cate",
      lastName: "Blanchett",
      email: "cblanchett@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Cate_Blanchett_Cannes_2018_2_%28cropped%29.jpg/330px-Cate_Blanchett_Cannes_2018_2_%28cropped%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 37,
      firstName: "Denzel",
      lastName: "Washington",
      email: "dwashington@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Denzel_Washington_2018.jpg/330px-Denzel_Washington_2018.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Elisabeth",
    },
    {
      id: 38,
      firstName: "Ellen",
      lastName: "DeGeneres",
      email: "edegeneres@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Ellen_DeGeneres_2011.jpg/330px-Ellen_DeGeneres_2011.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Simon",
    },
    {
      id: 39,
      firstName: "Hugh",
      lastName: "Jackman",
      email: "hjackman@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Logan_Japan_Premiere_Red_Carpet-_Hugh_Jackman_%2838445328406%29_%28rotated%29.jpg/330px-Logan_Japan_Premiere_Red_Carpet-_Hugh_Jackman_%2838445328406%29_%28rotated%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
    {
      id: 40,
      firstName: "Natalie",
      lastName: "Portman",
      email: "nportman@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Natalie_Portman_%2848470988352%29_%28cropped%29.jpg/330px-Natalie_Portman_%2848470988352%29_%28cropped%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Marianna",
    },
    {
      id: 41,
      firstName: "Al",
      lastName: "Pacino",
      email: "apacino@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Al_Pacino_2016_%2830401544240%29.jpg/330px-Al_Pacino_2016_%2830401544240%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Stefania",
    },
    {
      id: 42,
      firstName: "Scarlett",
      lastName: "Johansson",
      email: "sjohansson@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Scarlett_Johansson_by_Gage_Skidmore_2_%28cropped%2C_2%29.jpg/330px-Scarlett_Johansson_by_Gage_Skidmore_2_%28cropped%2C_2%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Carla",
    },
    {
      id: 43,
      firstName: "Anne",
      lastName: "Hathaway",
      email: "ahathaway@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Anne_Hathaway_for_AHC.png/330px-Anne_Hathaway_for_AHC.png",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 44,
      firstName: "Johnny",
      lastName: "Depp",
      email: "jdepp@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Johnny_Depp_2020.jpg/330px-Johnny_Depp_2020.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
    {
      id: 45,
      firstName: "Robert",
      lastName: "Downey Jr.",
      email: "rdowneyjr@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Robert_Downey_Jr_2014_Comic_Con_%28cropped%29.jpg/330px-Robert_Downey_Jr_2014_Comic_Con_%28cropped%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Stefania",
    },
    {
      id: 46,
      firstName: "Charlize",
      lastName: "Theron",
      email: "ctheron@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Charlize-theron-IMG_6045.jpg/330px-Charlize-theron-IMG_6045.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Carla",
    },
    {
      id: 47,
      firstName: "Leonardo",
      lastName: "Da Vinci",
      email: "lda.vinci@gmail.com",
      mobile: "+44123456789",
      image:
        "https://pbs.twimg.com/profile_images/1125818907955216385/DEWznmWU_400x400.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Elisabeth",
    },
    {
      id: 48,
      firstName: "Cameron",
      lastName: "Diaz",
      email: "cdiaz@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Cameron_Diaz_WE_2012_Shankbone_4.JPG/330px-Cameron_Diaz_WE_2012_Shankbone_4.JPG",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Simon",
    },
    {
      id: 49,
      firstName: "Jackie",
      lastName: "Chan",
      email: "jchan@hotmail.com",
      mobile: "+44123456789",
      image: "",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
    {
      id: 50,
      firstName: "Beyoncé",
      lastName: "Knowles",
      email: "bknowles@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Jackie_Chan_July_2016.jpg/330px-Jackie_Chan_July_2016.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Marianna",
    },
    {
      id: 51,
      firstName: "Daniel",
      lastName: "Radcliffe",
      email: "dradcliffe@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/DanielRadcliffe.jpg/330px-DanielRadcliffe.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Stefania",
    },
    {
      id: 52,
      firstName: "Gwyneth",
      lastName: "Paltrow",
      email: "gpaltrow@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/GwynethPaltrowByAndreaRaffin2011.jpg/330px-GwynethPaltrowByAndreaRaffin2011.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Carla",
    },
    {
      id: 53,
      firstName: "Marilyn",
      lastName: "Monroe",
      email: "mmonroe@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Monroecirca1953.jpg/330px-Monroecirca1953.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 54,
      firstName: "Tom",
      lastName: "Cruise",
      email: "tcruise@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Tom_Cruise_by_Gage_Skidmore_2.jpg/330px-Tom_Cruise_by_Gage_Skidmore_2.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Elisabeth",
    },
    {
      id: 55,
      firstName: "Audrey",
      lastName: "Hepburn",
      email: "ahepburn@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Audrey_Hepburn_1956.jpg/330px-Audrey_Hepburn_1956.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Simon",
    },
    {
      id: 56,
      firstName: "Harrison",
      lastName: "Ford",
      email: "hford@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Harrison_Ford_by_Gage_Skidmore_3.jpg/330px-Harrison_Ford_by_Gage_Skidmore_3.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
    {
      id: 57,
      firstName: "Elizabeth",
      lastName: "Taylor",
      email: "etaylor@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Elizabeth_Taylor%2C_late_1950s.jpg/330px-Elizabeth_Taylor%2C_late_1950s.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 58,
      firstName: "Grace",
      lastName: "Kelly",
      email: "gkelly@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Grace_Kelly30419.jpg/330px-Grace_Kelly30419.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Simon",
    },
    {
      id: 59,
      firstName: "Reese",
      lastName: "Witherspoon",
      email: "rwitherspoon@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Reese_Witherspoon_at_TIFF_2014.jpg/330px-Reese_Witherspoon_at_TIFF_2014.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Marianna",
    },
    {
      id: 60,
      firstName: "Joaquin",
      lastName: "Phoenix",
      email: "jphoenix@outlook.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Joaquin_Phoenix_in_2018.jpg/330px-Joaquin_Phoenix_in_2018.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "Stefania",
    },
    {
      id: 61,
      firstName: "Katherine",
      lastName: "Hepburn",
      email: "khepburn@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Katharine_Hepburn_promo_pic.jpg/330px-Katharine_Hepburn_promo_pic.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 62,
      firstName: "Sandra",
      lastName: "Bullock",
      email: "sbullock@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Sandra_Bullock_in_July_2013.jpg/330px-Sandra_Bullock_in_July_2013.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Carla",
    },
    {
      id: 63,
      firstName: "Emma",
      lastName: "Stone",
      email: "estone@hotmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Emma_Stone_at_Maniac_UK_premiere_%28cropped%29.jpg/330px-Emma_Stone_at_Maniac_UK_premiere_%28cropped%29.jpg",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: false,
      staff: "Julia",
    },
    {
      id: 64,
      firstName: "Marlon",
      lastName: "Brando",
      email: "mbrando@gmail.com",
      mobile: "+44123456789",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Marlon_Brando_publicity_for_One-Eyed_Jacks.png/330px-Marlon_Brando_publicity_for_One-Eyed_Jacks.png",
      query: "consumer",
      hasAppointment: true,
      confirmedAppointment: true,
      staff: "David",
    },
  ],

  bookings: [
    {
      id: 1,
      client: "Joaquin Phoenix",
      bookingDate: "15/05/2023",
      bookingTime: "16:30",
      confirmed: true,
      staff: "Stefania",
    },
    {
      id: 2,
      client: "Mariah Chan",
      bookingDate: "05/03/2023",
      bookingTime: "15:00",
      confirmed: true,
      staff: "David",
    },
    {
      id: 3,
      client: "Mark Wilson",
      bookingDate: "08/03/2023",
      bookingTime: "11:00",
      confirmed: false,
      staff: "Elisabeth",
    },
    {
      id: 4,
      client: "Bryan Kim",
      bookingDate: "05/03/2023",
      bookingTime: "12:00",
      confirmed: true,
      staff: "Julia",
    },
    {
      id: 5,
      client: "Alex Nguyen",
      bookingDate: "10/03/2023",
      bookingTime: "14:00",
      confirmed: false,
      staff: "David",
    },
    {
      id: 6,
      client: "Jason Lee",
      bookingDate: "15/03/2023",
      bookingTime: "09:30",
      confirmed: true,
      staff: "Roberto",
    },
    {
      id: 7,
      client: "Alice Lee",
      bookingDate: "02/03/2023",
      bookingTime: "16:00",
      confirmed: false,
      staff: "Elisabeth",
    },
    {
      id: 8,
      client: "Adam Kim",
      bookingDate: "02/03/2023",
      bookingTime: "14:30",
      confirmed: true,
      staff: "Marianna",
    },
    {
      id: 9,
      client: "Angelina Jolie",
      bookingDate: "05/15/2023",
      bookingTime: "12:00",
      confirmed: true,
      staff: "David",
    },
    {
      id: 10,
      client: "Meryl Streep",
      bookingDate: "06/05/2023",
      bookingTime: "14:30",
      confirmed: false,
      staff: "Elisabeth",
    },
    {
      id: 11,
      client: "Brad Pitt",
      bookingDate: "07/10/2023",
      bookingTime: "10:00",
      confirmed: true,
      staff: "Stefania",
    },
    {
      id: 12,
      client: "Daniel Radcliffe",
      bookingDate: "17/11/2023",
      bookingTime: "12:00",
      confirmed: true,
      staff: "Stefania",
    },
    {
      id: 13,
      client: "Charlize Theron",
      bookingDate: "08/02/2023",
      bookingTime: "11:30",
      confirmed: true,
      staff: "Marianna",
    },
    {
      id: 14,
      client: "Sophie Kim",
      bookingDate: "04/03/2023",
      bookingTime: "12:30",
      confirmed: true,
      staff: "Roberto",
    },
    {
      id: 15,
      client: "Melanie Wong",
      bookingDate: "05/03/2023",
      bookingTime: "12:30",
      confirmed: true,
      staff: "Julia",
    },
    {
      id: 16,
      client: "Emma Stone",
      bookingDate: "28/04/2023",
      bookingTime: "16:30",
      confirmed: false,
      staff: "Julia",
    },
    {
      id: 17,
      client: "Cate Blanchett",
      bookingDate: "10/22/2023",
      bookingTime: "15:30",
      confirmed: true,
      staff: "Carla",
    },
    {
      id: 18,
      client: "Ethan Chen",
      bookingDate: "06/03/2023",
      bookingTime: "11:30",
      confirmed: true,
      staff: "David",
    },
    {
      id: 19,
      client: "Rachel Kim",
      bookingDate: "04/03/2023",
      bookingTime: "09:30",
      confirmed: false,
      staff: "Roberto",
    },
    {
      id: 20,
      client: "Scarlett Johansson",
      bookingDate: "12/10/2023",
      bookingTime: "14:00",
      confirmed: true,
      staff: "Carla",
    },
    {
      id: 21,
      client: "Oprah Winfrey",
      bookingDate: "03/10/2023",
      bookingTime: "14:30",
      confirmed: false,
      staff: "Simon",
    },
    {
      id: 22,
      client: "Grace Kelly",
      bookingDate: "10/12/2023",
      bookingTime: "11:30",
      confirmed: false,
      staff: "Simon",
    },
    {
      id: 23,
      client: "Tom Cruise",
      bookingDate: "12/11/2023",
      bookingTime: "14:00",
      confirmed: true,
      staff: "Elisabeth",
    },
    {
      id: 24,
      client: "Sandra Bullock",
      bookingDate: "15/09/2023",
      bookingTime: "11:00",
      confirmed: true,
      staff: "Carla",
    },
    {
      id: 25,
      client: "Matt Damon",
      bookingDate: "09/09/2023",
      bookingTime: "10:30",
      confirmed: true,
      staff: "Roberto",
    },
    {
      id: 26,
      client: "Tom Hanks",
      bookingDate: "09/09/2023",
      bookingTime: "10:30",
      confirmed: true,
      staff: "Roberto",
    },
  ],
};

export default mockData;
